<template>
    <div v-if="$store.state.stringsStore.stringsLoaded" id="app">
        <router-view />
    </div>
</template>

<script>
export default {
  created() {
    if (!this.$store.state.stringsStore.stringsLoaded) {
      this.$store.dispatch('getStrings');
    }
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
      stringsLoaded: false,
    };
  },
  mounted() {
    // Text selection does not work when a module loads without first reloading the page.
    window.addEventListener('keydown', (event) => {
      if (event.target.tagName !== 'INPUT' || event.key !== 'a') return;

      const useMetaKey = navigator.platform.indexOf('Mac') > -1;

      // Cmd for mac, ctrl for windows
      const modifier = useMetaKey ? event.metaKey : event.ctrlKey;

      // Select the input text when ctrl+a is pressed
      if (modifier && event.key === 'a') {
        event.target.select();
      }
    });
  },
  destroyed() {
    window.removeEventListener('keydown', () => {});
  },
};
</script>

<style>
body {
  font-family: 'Droid Sans';
}
</style>
